<template>
  <div>
    <van-popup v-model="visible" position="top" :close-on-click-overlay="false">
      <div class="main" @click="onClose">
        <!-- <div class="center1"> -->
        <van-swipe :autoplay="3000" lazy-render>
          <van-swipe-item v-for="image in images" :key="image">
            <van-image :src="image" height="100%" fit="fill" />
          </van-swipe-item>
        </van-swipe>
        <!-- </div> -->
        <div class="tip">
          <span class="animate__animated animate__flash animate__infinite animate__slower">
            <van-image :src="btn_start" height="5rem" />
          </span>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<style scoped>
.center1 {
  display: flex;
  /* 水平置中 */
  justify-content: center;
  /* 垂直置中 */
  align-items: center;
  margin: auto;
}

.van-popup,
.main {
  height: 100vh;
  width: 100%;
  padding: 0;
  background-color: #333;
}

.van-swipe {
  height: 100%;
  width: 100%;
}

.tip {
  position: fixed;
  left: 50%;
  bottom: 0rem;
  transform: translate(-50%, -50%);
}

.van-image {
  padding: 0;
  margin: 0;
  width: 100%;
}
</style>
<script>
export default {
  data() {
    return {
      visible: false,
      images: [],
      btn_start: require("@/assets/btn-start.png"),
    };
  },
  methods: {
    show() {
      var images = [];
      var img = this.sGetConfig("welcome1");
      img && images.push(img);

      img = this.sGetConfig("welcome2");
      img && images.push(img);

      img = this.sGetConfig("welcome3");
      img && images.push(img);
      this.images = images;

      this.visible = true;
    },
    async onClose() {
      if (this.sGetConfig("kioskMode")) await this.gInit();
      console.log("onClose FrmWelcome");

      let tblid = this.$route.query.tblid;
      if (tblid == "外帶") this.$store.commit("setPotype", "外帶");

      this.$emit("close");
      this.visible = false;
    },
  },
};
</script>
